import React from 'react'
// import Home1 from './Pages/Home1'
import { Route, Routes } from 'react-router-dom'
import Home from './Pages/Home'
import Navbar from './Components/Navbar'
import About from './Pages/About'
import WhyChooseUs from './Pages/WhyChooseUs'
import Services from './Pages/Services'
import Contactus from './Pages/Contactus'
import Footer from './Components/Footer'
import ErrorPage from './Components/ErrorPage'
import Quote from './Pages/Quote'

const App = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/why-choose-us' element={<WhyChooseUs/>}/>
        <Route path='/service' element={<Services />}/>
        <Route path='/contact' element={<Contactus />}/>
        <Route path='/quote' element={<Quote />} />
        <Route path='*'  element={<ErrorPage />} />
      </Routes>
      <Footer />
    </div>
  )
}

export default App
